// Mixin das listagens de arquivos importados (itens 4/5).
//
// Contrato do componente consumidor:
// - methods: listingItems() (itens da página corrente), handleSend(item)
//   (mesma ação do ícone de detalhe) e actionLabelKey(file) (labelKey do
//   radio do modal para o arquivo — null quando a combinação não mapeia)
import { resolveClickedRowItem } from '@/helpers/listing-table'

const listingTableMixin = {
  methods: {
    // Item 4 — clique em qualquer área da linha abre o detalhe do arquivo,
    // mesma ação do ícone (reusa handleSend). Guards no helper: elementos
    // interativos (sem disparo duplo) e drag de seleção de texto (B5). O
    // ícone segue como caminho acessível por teclado.
    handleRowClick(event) {
      const item = resolveClickedRowItem(event, this.listingItems())
      if (!item) return

      this.handleSend(item)
    },
    // Item 5 — rótulo da opção de importação do arquivo: mesmo texto do
    // radio do modal; combinação desconhecida exibe '--' (não quebra)
    mapActionLabel(file) {
      const labelKey = this.actionLabelKey(file)
      return labelKey ? this.$t(labelKey) : '--'
    },
  },
}

export { listingTableMixin }
